import { createErrorBoundary } from '../../../components/error/CreateErrorBoundary';

export const ExportErrorBoundary = createErrorBoundary({
  name: 'ExportErrorBoundary',
  logMessage: 'Block Builder export error',
  titleKey: 'exportErrorTitle',
  bodyKey: 'exportErrorBody',
  logContext: { page: 'block-export' },
});
